module.exports = __webpack_public_path__ + "img/icon_3_36.5a91a492.png";